(() => {
  const initGallery = (root) => {
    if (!root || root.dataset.dpgReady === 'true') return;
    root.dataset.dpgReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-dpg-card]'));
    const filters = Array.from(root.querySelectorAll('[data-dpg-filter]'));
    const lightbox = root.querySelector('[data-dpg-lightbox]');
    const image = root.querySelector('[data-dpg-lightbox-image]');
    const title = root.querySelector('[data-dpg-lightbox-title]');
    const description = root.querySelector('[data-dpg-lightbox-description]');
    const closeButton = root.querySelector('.dpg__lightbox-close');
    const previousButton = root.querySelector('[data-dpg-prev]');
    const nextButton = root.querySelector('[data-dpg-next]');
    let visibleCards = cards.slice();
    let activeIndex = 0;
    let trigger = null;

    if (!cards.length || !lightbox || !image) return;

    const show = (index) => {
      if (!visibleCards.length) return;
      activeIndex = (index + visibleCards.length) % visibleCards.length;
      const card = visibleCards[activeIndex];
      const cardImage = card.querySelector('img');
      image.src = card.dataset.image;
      image.alt = card.dataset.alt || (cardImage ? cardImage.alt : card.dataset.title);
      if (title) title.textContent = card.dataset.title || '';
      if (description) description.textContent = card.dataset.description || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dpg-no-scroll');
      if (closeButton) closeButton.focus();
    };

    const close = () => {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dpg-no-scroll');
      if (trigger) trigger.focus();
    };

    cards.forEach((card) => card.addEventListener('click', () => {
      trigger = card;
      show(visibleCards.indexOf(card));
    }));

    filters.forEach((button) => button.addEventListener('click', () => {
      const team = button.dataset.dpgFilter;
      filters.forEach((filter) => {
        const active = filter === button;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => { card.hidden = team !== 'all' && card.dataset.team !== team; });
      visibleCards = cards.filter((card) => !card.hidden);
      activeIndex = 0;
      if (!lightbox.hidden) close();
    }));

    root.querySelectorAll('[data-dpg-close]').forEach((element) => element.addEventListener('click', close));
    if (previousButton) previousButton.addEventListener('click', () => show(activeIndex - 1));
    if (nextButton) nextButton.addEventListener('click', () => show(activeIndex + 1));

    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      if (event.key === 'ArrowRight') show(activeIndex + 1);
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-dpg-root]').forEach(initGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
